import { ArrowOutward } from '@mui/icons-material';
import { type RpmPicks } from '@on3/api';
import { Avatar } from '@on3/ui-lib/components/Avatar';
import clsx from 'clsx';

import styles from './RpmPercentChange.module.scss';

export const RpmPercentChange = ({ pick }: { pick: RpmPicks }) => {
  const { topTeams = [] } = pick;

  const topTeam = topTeams[0];

  if (!topTeam.currentPercentage) return null;

  const teamName =
    topTeam.organization?.name || topTeam.organization?.fullName || 'Team';
  const changeDirection =
    topTeam.currentPercentage > (topTeam.previousPercentage ?? 0) ? 1 : -1;

  return (
    <div className={styles.block}>
      <dl className={styles.team}>
        <dt>{teamName}</dt>
        <dd className={styles.changeContainer}>
          <div className={styles.change}>
            <figure>
              <Avatar
                altText={`${topTeam.organization?.name} avatar`}
                className={styles.avatar}
                domain={topTeam.organization?.asset?.domain}
                height={20}
                source={topTeam.organization?.asset?.source}
                teamAvatar
                title={teamName}
                width={20}
              />
            </figure>
            <div className={styles.rankContainer}>
              <span>#{topTeam.previousRank}</span>
              <span>({topTeam.previousPercentage?.toFixed(0)}%)</span>
            </div>
          </div>

          <ArrowOutward
            className={clsx(styles.arrow, {
              [styles.up]: changeDirection === 1,
              [styles.down]: changeDirection === -1,
            })}
          />

          <div className={styles.change}>
            <div className={styles.rankContainer}>
              <span>#{topTeam.currentRank}</span>
              <span>({topTeam.currentPercentage?.toFixed(0)}%)</span>
            </div>
          </div>
        </dd>
      </dl>
    </div>
  );
};
